"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageNavigator = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const react_transition_group_1 = require("react-transition-group");
const styled_components_1 = __importDefault(require("styled-components"));
const ArrowButton_1 = require("../../atoms/ArrowButton/ArrowButton");
const Progressbar_1 = require("../../atoms/Progressbar/Progressbar");
const ANIMATION_DURATION = 200;
/**
 * Page navigator component. It displays current progress of available pages.
 * @constructor
 */
function PageNavigator({ currentPage = 0, pageCount = 1, onGoBack, onGoNext, canGoBack = true, canGoNext = true, className, show = true, onProgressbarAppearAnimationEnd = () => { }, onProgressbarDisappearAnimationEnd = () => { }, }) {
    const [isProgressbarVisible, setIsProgressbarVisible] = react_1.default.useState(false);
    const progressbarRef = react_1.default.useRef(null);
    const backButtonRef = react_1.default.useRef(null);
    const forwardButtonRef = react_1.default.useRef(null);
    /**
     * Show navigation buttons only when progressbar animation is finished
     * Disappear navigation buttons when progressbar disappear animation starts
     */
    const showNavigationButtons = show && isProgressbarVisible;
    return ((0, jsx_runtime_1.jsxs)(Container, { className: className, "data-e2e": 'PageNavigator_Container', children: [(0, jsx_runtime_1.jsx)(ArrowButtonPlaceholder, { "data-e2e": 'PageNavigator_ArrowButtonPlaceholder', children: (0, jsx_runtime_1.jsx)(react_transition_group_1.CSSTransition, { in: showNavigationButtons, timeout: ANIMATION_DURATION, appear: true, mountOnEnter: true, unmountOnExit: true, nodeRef: backButtonRef, "data-e2e": 'PageNavigator_CSSTransition', children: (0, jsx_runtime_1.jsx)(StyledArrowButton, { onClick: onGoBack, disabled: !canGoBack, direction: ArrowButton_1.Direction.Left, ref: backButtonRef, "data-e2e": 'PageNavigator_StyledArrowButton' }) }) }), (0, jsx_runtime_1.jsx)(react_transition_group_1.CSSTransition, { in: show, timeout: ANIMATION_DURATION, onEntered: () => {
                    setIsProgressbarVisible(true);
                    onProgressbarAppearAnimationEnd();
                }, onExited: () => {
                    setIsProgressbarVisible(false);
                    onProgressbarDisappearAnimationEnd();
                }, appear: true, nodeRef: progressbarRef, "data-e2e": 'PageNavigator_CSSTransition', children: (0, jsx_runtime_1.jsx)(StyledProgressbar, { max: pageCount, value: currentPage + 1, ref: progressbarRef, "data-e2e": 'PageNavigator_StyledProgressbar' }) }), (0, jsx_runtime_1.jsx)(ArrowButtonPlaceholder, { "data-e2e": 'PageNavigator_ArrowButtonPlaceholder', children: (0, jsx_runtime_1.jsx)(react_transition_group_1.CSSTransition, { in: showNavigationButtons, timeout: ANIMATION_DURATION, appear: true, mountOnEnter: true, unmountOnExit: true, nodeRef: forwardButtonRef, "data-e2e": 'PageNavigator_CSSTransition', children: (0, jsx_runtime_1.jsx)(StyledArrowButton, { onClick: onGoNext, disabled: !canGoNext, direction: ArrowButton_1.Direction.Right, ref: forwardButtonRef, "data-e2e": 'PageNavigator_StyledArrowButton' }) }) })] }));
}
exports.PageNavigator = PageNavigator;
/**
 * Placeholder uses to keep the same size of the arrow button when it's hidden
 */
const ArrowButtonPlaceholder = styled_components_1.default.div `
  width: 22px;
  height: 22px;
`;
const StyledArrowButton = (0, styled_components_1.default)(ArrowButton_1.ArrowButton) `
  &.enter,
  &.appear {
    opacity: 0;
  }

  &.enter-active,
  &.appear-active {
    opacity: 1;
    transition: opacity ${ANIMATION_DURATION}ms ease-in;
  }

  &.exit {
    opacity: 1;
  }

  &.exit-active {
    opacity: 0;
    transition: opacity ${ANIMATION_DURATION}ms ease-in;
  }
`;
const StyledProgressbar = (0, styled_components_1.default)(Progressbar_1.Progressbar) `
  opacity: 0;

  &.enter,
  &.appear {
    opacity: 0;
  }

  &.enter-active,
  &.appear-active {
    opacity: 1;
    transition: opacity ${ANIMATION_DURATION}ms ease-in;
  }

  &.enter-done,
  &.appear-done {
    opacity: 1;
  }

  &.exit {
    opacity: 1;
  }

  &.exit-active {
    opacity: 0;
    transition: opacity ${ANIMATION_DURATION}ms ease-in;
  }

  &.exit-done {
    opacity: 0;
  }
`;
const Container = styled_components_1.default.div `
  width: 100%;

  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 16px;
`;
